<h2  style="text-align:center;margin-bottom: 0;">{{data.title}}</h2>
<mat-dialog-content id="print-section" style="padding-top: 0;">
    <app-table *ngIf="datiControlli; else noData" matSort [data]="datiControlli"
    [columns]="columnsControlli" 
    [crud]="controlloDettaglioService"
    insertFormSize="full" 
    insertFormTitle="Controlli"
    >
    <ng-content></ng-content>

  </app-table>
  <ng-template #noData>
    Nessun Dato da Visualizzare
  </ng-template>
    <!-- <p style="text-align:center;margin-top:0">{{data.idPuntoCampionamento}}</p> -->
</mat-dialog-content>
<mat-dialog-actions class="my-padding-dialog justify-content-end">
    <button  mat-flat-button printSectionId="print-section" ngxPrint color="success" style="margin-right: 5px;">Stampa</button>
    <app-button label="Chiudi" [fullWidth]="false" (click)="closeModal()" raised></app-button>
</mat-dialog-actions>